<template>
  <v-switch
    :input-value="value"
    :ripple="ripple"
    class="sn-switch"
    :inset="inset"
    color="snBrand"
    :flat="inset"
    :label="label"
    :hide-details="hideDetails"
    :disabled="disabled"
    :readonly="readonly"
    v-on="$listeners"
  />
</template>

<script>
export default ({
  name: 'SnSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inset: {
      type: Boolean,
      default: true
    },
    ripple: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  }
})
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.sn-switch ::v-deep {
  // .v-input--is-label-active .v-input--switch__track {
  //   background-color: red !important;
  // }
  .v-input--switch {
    &__track {
      border: none;
      opacity: 1;
    }
  }
}
</style>
